import { render, staticRenderFns } from "./CustomerReportTabOrders.vue?vue&type=template&id=a4354a06&scoped=true"
import script from "./CustomerReportTabOrders.vue?vue&type=script&lang=js"
export * from "./CustomerReportTabOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4354a06",
  null
  
)

export default component.exports